module.exports = __webpack_public_path__ + "static/media/FastShipping.6c3f1744.png";